/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Link } from 'react-router-dom';

const asideItem = {
  title: '회원정보',
  contents: [
    { url: '/order/shipping', text: '주문내역조회' },
    { url: '/mypage', text: '마이페이지' },
  ],
};

export function AsideMyinfo() {
  return (
    <aside>
      <h3>{asideItem.title}</h3>
      {asideItem.contents.map((element, i) => (
        <Link to={element.url} key={i}>
          {element.text}
        </Link>
      ))}
    </aside>
  );
}
